<div class="d-flex gap-2 flex-wrap">
    <div *ngFor="let r of regions$ | async">
        <div class="d-flex align-items-center">
            <label
                [for]="'region_options_item' + r.id + ''"
                class="d-inline-flex gap-1 align-items-center ms-3 cursor-pointer"
            >
                <p-radioButton
                    [inputId]="'region_options_item' + r.id + ''"
                    [value]="r.id"
                    [ngModel]="selectionModel.selected[0]"
                    (ngModelChange)="selectionModel.select($event); onTouchedFn?.()"
                    name="regions-select"
                />
                <app-region-name [regionId]="r.id" />
            </label>
        </div>
    </div>
    <div *ngIf="showNone">
        <div class="d-flex align-items-center">
            <label
                [for]="'region_options_item_none'"
                class="d-inline-flex gap-1 align-items-center ms-3 cursor-pointer"
            >
                <p-radioButton
                    [inputId]="'region_options_item_none'"
                    [value]="null"
                    [ngModel]="selectionModel.selected[0]"
                    (ngModelChange)="selectionModel.select($event); onTouchedFn?.()"
                    name="regions-select"
                />
                <span>无</span>
            </label>
        </div>
    </div>
</div>
